import App from '@/main'

export const durations: Record<any, any> = {
  1: App.$t('untilExpired'),
}
export const frequencies: Record<any, any> = {
  // 1: App.$t('daily'),
  2: App.$t('weekly'),
  3: App.$t('monthly'),
  4: App.$t('3months'),
  5: App.$t('6months'),
  6: App.$t('annually'),
  7: App.$t('3days'),
}

export default durations
